import PropTypes from 'prop-types';
import * as Styled from './LoadingFlavourText.styled';

export const LoadingFlavourText = (props) => {
  // gets flavour text based on the current progress (as progress goes up, the flavour text will change)
  // an alternative method might be to do it on an interval
  const getFlavourText = (progress) => {
    const defaultFlavourText = 'Loading...';
    if (!props.loadingFlavourTexts) {
      return defaultFlavourText;
    }
    const percIncrement = 100 / props.loadingFlavourTexts.length;
    // return first text that goes over current progress
    for (let i = 0; i < props.loadingFlavourTexts.length; i++) {
      if (
        // some mathematical overlap with >= and <= but means we capture 0 and 100
        progress >= i * percIncrement &&
        progress <= (i + 1) * percIncrement
      ) {
        return props.loadingFlavourTexts[i];
      }
    }
    // shouldn't reach this point
    return defaultFlavourText;
  };
  // const [flavourTextIndex, setFlavourTextIndex] = useState(0);
  // const [intervalDelay, setIntervalDelay] = useState(1000);
  // if (!props.loadingFlavourTexts) {
  //   console.error(
  //     'ERROR: <LoadingFlavourText /> needs loadingFlavourTexts to be an array of strings '
  //   );
  // }
  // useInterval(() => {
  //   if (!props.loadingFlavourTexts) return;
  //   let newIndex = flavourTextIndex + 1;
  //   if (newIndex < props.loadingFlavourTexts.length) {
  //     setFlavourTextIndex(newIndex);
  //   } else {
  //     setFlavourTextIndex(0);
  //   }
  //   setIntervalDelay(GetRandomInt(1000, 2000));
  // }, intervalDelay);
  return (
    <Styled.LoadingFlavourText>
      {getFlavourText(props.progress)}
    </Styled.LoadingFlavourText>
  );
};

LoadingFlavourText.propTypes = {
  progress: PropTypes.number.isRequired,
  loadingFlavourTexts: PropTypes.arrayOf(PropTypes.string.isRequired)
    .isRequired,
};
